'use client';

import { useLayoutEffect, useRef } from 'react';
import { useCallRailContext } from '@/components/CallRail/CallRailProvider';
import { CallRailReadyGateProps } from './types';

export default function CallRailReadyGate({ children }: CallRailReadyGateProps) {
  const containerRef = useRef<HTMLSpanElement>(null);
  const { callRailReady, hasCallRailIntegration } = useCallRailContext();

  useLayoutEffect(() => {
    if (!hasCallRailIntegration || !callRailReady || !containerRef.current) {
      return;
    }

    window.CallTrk?.swap?.(containerRef.current);
  }, [hasCallRailIntegration, callRailReady]);

  if (!hasCallRailIntegration) {
    return <>{children}</>;
  }

  return (
    <>
      <span
        ref={containerRef}
        className={callRailReady ? 'callrail-ready contents' : 'callrail-fallback contents'}
        style={{
          visibility: callRailReady ? 'visible' : 'hidden',
        }}
      >
        {children}
      </span>
      <noscript>
        <style>{`.callrail-fallback { visibility: visible !important; }`}</style>
      </noscript>
    </>
  );
}
